export const config = {
  chain: "Evmos",
};
